import { ProductType } from '@features/products/enums/productType'

import { DemoInvoiceUnit } from '../enums/demoInvoiceUnit'
import { DemoInvoiceProduct } from '../types/demoInvoiceProduct'

export const DEMO_INVOICE_PRODUCTS: DemoInvoiceProduct[] = [
  {
    id: 'demo-product-1',
    productType: ProductType.Services,
    tName: 'demo_invoice.fixtures.products.website_design',
    unit: DemoInvoiceUnit.Forfait,
    unitPrice: 1200,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-2',
    productType: ProductType.Services,
    tName: 'demo_invoice.fixtures.products.consulting_hour',
    unit: DemoInvoiceUnit.Hour,
    unitPrice: 90,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-3',
    productType: ProductType.Goods,
    tName: 'demo_invoice.fixtures.products.printed_flyers',
    unit: DemoInvoiceUnit.Unit,
    unitPrice: 0.35,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-4',
    productType: ProductType.Goods,
    tName: 'demo_invoice.fixtures.products.book',
    unit: DemoInvoiceUnit.Unit,
    unitPrice: 25,
    vatRatePercent: 0.055,
  },
]
